export function getFullImagePath(character) {
  return character.image;
}

export function getThumbnailPath(character) {
  return character.thumb;
}
